import { render, staticRenderFns } from "./ModalVisualizaMatricula.vue?vue&type=template&id=db81e990"
import script from "./ModalVisualizaMatricula.vue?vue&type=script&lang=js"
export * from "./ModalVisualizaMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports